import { gql } from "@apollo/client";

export const SENTRY_SESSION_STATUS_SUBSCRIPTION = gql`
    subscription SentrySessionStatus {
        sentrySessionStatus {
            sessionId
            hasActiveSession
            hasActiveStreamSession
            startTime
            endTime
            doubleSentry
            checkinCount
        }
    }
`;
